var __vue_script__, __vue_template__
__vue_template__ = require("!!vue-html-loader!./../../node_modules/vue-loader/lib/selector.js?type=template&index=0!./Home.vue")
module.exports = __vue_script__ || {}
if (module.exports.__esModule) module.exports = module.exports.default
if (__vue_template__) {
(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
}



/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Home.vue
 ** module id = 155
 ** module chunks = 0
 **/